import { AspectRatio, Box, Image, BoxProps } from "@chakra-ui/react";
import { publicUrl } from "config";

export type EmptyNftCardProps = BoxProps;

const EmptyNftCard = ({ children, ...rest }: EmptyNftCardProps) => (
  <Box
    bg="dark.700"
    p="1.5"
    w="full"
    userSelect="none"
    borderRadius="lg"
    overflow="hidden"
    {...rest}
  >
    <AspectRatio
      ratio={1}
      w="full"
      bg="dark.800"
      borderRadius="md"
      overflow="hidden"
    >
      <Image
        src={`${publicUrl}/v2-placeholder_transparent.png`}
        w="full"
        position="absolute"
        opacity={0.3}
      />
    </AspectRatio>

    <Box>{children}</Box>
  </Box>
);

export default EmptyNftCard;
